import React from 'react';

interface LoadingStateProps {
  status?: string;
  showDetails?: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ 
  status = "Conectando ao WhatsApp...", 
  showDetails = true 
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center wa-gradient-bg wa-animate-fadeIn" style={{ padding: 'var(--wa-space-4)' }}>
      <div className="wa-card wa-card-body text-center" style={{ maxWidth: '28rem', width: '100%' }}>
        {/* Animated Logo */}
        <div style={{ marginBottom: 'var(--wa-space-8)' }}>
          <div 
            className="wa-gradient-yellow-primary flex items-center justify-center mx-auto wa-animate-bounce"
            style={{ 
              width: 'var(--wa-space-20)', 
              height: 'var(--wa-space-20)', 
              borderRadius: 'var(--wa-rounded-full)',
              marginBottom: 'var(--wa-space-6)',
              border: '2px solid var(--wa-yellow-400)',
              boxShadow: '0 4px 15px rgba(255, 193, 7, 0.3)'
            }}
          >
            <span style={{ fontSize: 'var(--wa-text-3xl)', color: 'var(--wa-yellow-900)' }}>📱</span>
          </div>
        </div>

        {/* Loading Animation */}
        <div style={{ marginBottom: 'var(--wa-space-8)' }}>
          <div 
            className="relative mx-auto"
            style={{ 
              width: 'var(--wa-space-16)', 
              height: 'var(--wa-space-16)', 
              marginBottom: 'var(--wa-space-6)' 
            }}
          >
            {/* Outer ring */}
            <div 
              className="absolute inset-0"
              style={{ 
                border: '4px solid var(--wa-yellow-200)',
                borderRadius: 'var(--wa-rounded-full)'
              }}
            ></div>
            {/* Spinning ring */}
            <div 
              className="absolute inset-0 wa-animate-spin"
              style={{ 
                border: '4px solid var(--wa-yellow-500)',
                borderTopColor: 'transparent',
                borderRadius: 'var(--wa-rounded-full)'
              }}
            ></div>
            {/* Inner dot */}
            <div 
              className="absolute wa-animate-ping"
              style={{ 
                backgroundColor: 'var(--wa-yellow-600)',
                borderRadius: 'var(--wa-rounded-full)',
                top: 'var(--wa-space-4)',
                left: 'var(--wa-space-4)',
                right: 'var(--wa-space-4)',
                bottom: 'var(--wa-space-4)'
              }}
            ></div>
          </div>
          
          <h2 className="wa-heading-4" style={{ marginBottom: 'var(--wa-space-2)' }}>
            {status}
          </h2>
          <p className="wa-body-small" style={{ color: 'var(--wa-gray-500)' }}>
            Isso pode levar alguns segundos...
          </p>
        </div>

        {/* Progress Steps */}
        {showDetails && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--wa-space-4)' }}>
            <div className="flex items-center wa-body-small" style={{ gap: 'var(--wa-space-3)' }}>
              <div 
                className="wa-animate-pulse"
                style={{ 
                  width: 'var(--wa-space-2)', 
                  height: 'var(--wa-space-2)', 
                  borderRadius: 'var(--wa-rounded-full)',
                  backgroundColor: 'var(--wa-yellow-500)' 
                }}
              ></div>
              <span style={{ color: 'var(--wa-gray-600)' }}>Estabelecendo conexão WebSocket</span>
            </div>
            <div className="flex items-center wa-body-small" style={{ gap: 'var(--wa-space-3)' }}>
              <div 
                className="wa-animate-pulse"
                style={{ 
                  width: 'var(--wa-space-2)', 
                  height: 'var(--wa-space-2)', 
                  borderRadius: 'var(--wa-rounded-full)',
                  backgroundColor: 'var(--wa-yellow-600)' 
                }}
              ></div>
              <span style={{ color: 'var(--wa-gray-600)' }}>Inicializando sessão WhatsApp</span>
            </div>
            <div className="flex items-center wa-body-small" style={{ gap: 'var(--wa-space-3)' }}>
              <div 
                style={{ 
                  width: 'var(--wa-space-2)', 
                  height: 'var(--wa-space-2)', 
                  borderRadius: 'var(--wa-rounded-full)',
                  backgroundColor: 'var(--wa-yellow-300)' 
                }}
              ></div>
              <span style={{ color: 'var(--wa-gray-400)' }}>Gerando QR Code</span>
            </div>
          </div>
        )}

        {/* Tip */}
        <div 
          style={{ 
            marginTop: 'var(--wa-space-8)',
            padding: 'var(--wa-space-4)',
            backgroundColor: 'var(--wa-yellow-50)',
            border: `1px solid var(--wa-yellow-200)`,
            borderRadius: 'var(--wa-rounded-xl)'
          }}
        >
          <p className="wa-caption" style={{ color: 'var(--wa-yellow-800)' }}>
            💡 <strong>Dica:</strong> Mantenha seu WhatsApp Web fechado para evitar conflitos
          </p>
        </div>
      </div>
    </div>
  );
};